import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Link } from 'react-router-dom'
import Icon from '@components/Icon'
import { SetFlex, LinkStyle } from './style'

const NavbarLink = (props) => {
  const { children, to, icon, size, underline, handleClick } = props

  const className = classNames(LinkStyle.basic, size, {
    [`${SetFlex.flex}`]: icon,
    underline: underline,
  })

  return (
    <Link className={className} to={to} size={size} onClick={handleClick}>
      {children}
      <span>{icon && <Icon icon={icon} />}</span>
    </Link>
  )
}

NavbarLink.propTypes = {
  children: PropTypes.any,
  to: PropTypes.string,
  icon: PropTypes.string,
  size: PropTypes.string,
  handleClick: PropTypes.func,
}

export default NavbarLink
